<template>
  <div class="rhch-upload-container" :class="{'is-disabled': disabled, 'is-error': showError}">
    <el-upload
      class="rhcn-upload"
      drag
      :file-list="fileList"
      action="#"
      :multiple="false"
      :auto-upload="false"
      :accept="accept"
      :show-file-list="false"
      :limit="limit"
      :on-preview="previewHandler"
      :on-success="successHandler"
      :on-error="errorHandler"
      :on-progress="progressHandler"
      :on-change="changeHandler"
      :on-exceed="exceedHandler"
      :disabled="disabled || uploading">
      <div class="el-upload__text">
        <div v-if="!uploading" class="text">
          <span v-if="!uploadTips" class="el-icon-plus upload-icon-plus"></span>
          <span v-else v-html="uploadTips"></span>
        </div>
        <div v-if="uploading" class="el-upload__process__text">
          <div class="el-upload__rate">{{uploadProgress}}%</div>
          <div class="el-upload__loading">Uploading…</div>
        </div>
        <el-button :disabled="uploading || disabled" type="primary" size="small">{{$t('message.settlement.uploadFile')}}</el-button>
      </div>
    </el-upload>
    <div v-show="uploading" class="rhch-upload-progress">
      <div class="rhch-upload-progress-rate" :style="{'width': `${uploadProgress}%`}"></div>
    </div>
    <div class="rhch-file-list">
      <template v-for="(item, index) in fileList">
        <div :key="index" class="rhch-file-item">
          <div class="item-left">
            <span class="thumbnail-box" v-if="getFileType(item.name) === 'excel'">
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-excl thumbnail" style="color: #79CF64;"></span>
              </span>
            </span>
            <span class="thumbnail-box" v-else-if="getFileType(item.name) === 'word'">
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-word thumbnail" style="color: #264373;"></span>
              </span>
            </span>
            <span class="thumbnail-box img-box" v-else-if="getFileType(item.name) === 'image'">
              <el-image :ref="`thumbnail${index}`" class="thumbnail-img" fit="cover" :src="item.url" :preview-src-list="[item.url]"></el-image>
            </span>
            <span class="thumbnail-box" v-else>
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-other1 thumbnail"></span>
              </span>
            </span>
            <div>
              <!-- 文件名 -->
              <div class="rhcn-filename">Files {{item.name}}</div>
              <!-- 文件大小，上传时间 -->
              <!-- <div class="rhcn-description">
                <span class="rhch-filesize" v-if="item.size">{{gerFileSize(item.size)}}</span>
                <span>{{$t('message.dispute.appealFileTime')}}: {{item.uploadTime}}</span>
              </div> -->
            </div>
          </div>
          <div class="rhch-acctions">
            <a class="rhch-action"
              target="_blank"
              :download="item.name"
              :href="item.url"
              v-if="getFileType(item.name) !== 'image' && item.url"><span class="iconfont icon-Download"></span></a>
            <span class="rhch-action"
              v-if="getFileType(item.name) === 'image'"
              @click="previewImage(item, index)"><span class="iconfont icon-veiw"></span></span>
            <span class="rhch-action"
              @click="removeHandler(item, index)"><span class="el-icon-close"></span></span>
          </div>
        </div>
      </template>
    </div>
    <!-- <div v-if="tip" class="rhcn-upload__tip">{{tip}}</div> -->
    <div v-if="showError" class="rhcn-upload__tip error">{{errorTip}}</div>
  </div>
</template>
<script>
export default {
  name: 'rhcn-upload',
  props: {
    accept: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadTips: {
      type: String,
      default: '',
    },
    tip: {
      type: String,
      default: '',
    },
    uploading: { // 是否上传中
      type: Boolean,
      default: false,
    },
    uploadProgress: { // 文件上传进度, uploading为true时有效
      type: Number,
      default: 0,
    },
    fileList: { // 已上传文件列表
      type: Array,
      default: () => [], // {name, url, size}
    },
    fileSize: { // 上传文件大小限制，若为0，则不限制
      type: Number,
      default: 5,
    },
    fileSizeUnit: { // 上传文件大小单位，默认M
      type: String,
      default: 'M',
    },
    onChange: { // 与 emits 中 on-change 取其一，便于外层高级函数调用
      type: Function,
      default: null,
    },
    onRemove: { // 与 emits 中 on-remove 取其一，便于外层高级函数调用
      type: Function,
      default: null,
    },
  },
  emits: ['on-preview', 'on-remove', 'on-success', 'on-error', 'on-progress', 'on-change', 'before-upload', 'before-remove'],
  data() {
    return {
      list: [],
      fileTypes: {
        excel: ['csv', 'xls', 'xlsx'],
        word: ['doc', 'docx'],
        image: ['jpg', 'png', 'gif', 'bmp', 'jpeg'],
      },
      showError: false,
      errorTip: '',
    };
  },
  methods: {
    previewHandler(file) {
      this.$emit('on-preview', file);
    },
    removeHandler(item, index) {
      this.showError = false;
      if (this.onRemove) {
        this.onRemove(item, index);
        return;
      }
      this.$emit('on-remove', item, index);
    },
    successHandler(response, file, fileList) {
      this.$emit('on-success', response, file, fileList);
    },
    errorHandler(err, file, fileList) {
      console.log(err);
      this.$emit('on-error', err, file, fileList);
    },
    progressHandler(event, file, fileList) {
      this.$emit('on-progress', event, file, fileList);
    },
    changeHandler(file, fileList) {
      if (this.fileSize) {
        let isLtM = file.size / 1024 / 1024 > this.fileSize;
        if (this.fileSizeUnit.toLowerCase() === 'kb') {
          isLtM = file.size / 1024 > this.fileSize;
        }
        if (isLtM) {
          this.errorTip = `${this.$t('message.validator.fileCannot')}${this.fileSize}M`;
          this.showErrorHandler();
          return;
        }
      }
      if (this.onChange) {
        this.onChange(file, fileList);
        return;
      }
      this.$emit('on-change', file, fileList);
    },
    beforeRemoveHandler(file, fileList) {
      this.$emit('before-remove', file, fileList);
    },
    exceedHandler(files, fileList) {
      this.errorTip = this.$t('message.upload.limitTip');
      this.showErrorHandler();
    },
    previewImage(item, index) {
      const thumbnail = this.$refs[`thumbnail${index}`];
      if (thumbnail && thumbnail.length) {
        thumbnail[0].showViewer = true;
      }
    },
    getFileType(fileName) {
      const fileNameArr = fileName.split('.');
      const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
      if (this.fileTypes.excel.indexOf(ext) > -1) {
        return 'excel';
      }
      if (this.fileTypes.word.indexOf(ext) > -1) {
        return 'word';
      }
      if (this.fileTypes.image.indexOf(ext) > -1) {
        return 'image';
      }
      return '';
    },
    showErrorHandler() {
      this.showError = true;
    },
    gerFileSize(size) {
      const sizeM = (size / 1024 / 1024).toFixed(2);
      if (sizeM > 0) {
        return `${sizeM}M`;
      }
      const sizeKB = (size / 1024).toFixed(2);
      return `${sizeKB}KB`;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.rhch-upload-container {
  position: relative;
  width: 100%;
  min-width: 590px;
  .rhcn-upload {
    .el-upload {
      .el-upload-dragger {
        background: $color-default;
        border: 2px solid $color-default;
        border-radius: 2px;
        width: 100%;
        min-width: 590px;
        height: 184px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: $color-border-active;
        }
        .el-upload__text {
          font-size: 14px;
          font-weight: 800;
          line-height: 22px;
          color: $color-text-primary;
          .text {
            margin-bottom: 8px;
          }
          .upload-icon-plus {
            font-size: 20px;
            font-weight: bold;
            color: $color-text-default-button;
          }
          .el-upload__process__text {
            margin-bottom: 8px;
            .el-upload__rate {
              font-weight: 800;
              font-size: 24px;
            }
            .el-upload__loading {
              font-weight: 800;
              font-size: 14px;
              line-height: 22px;
              margin-top: 9px;
            }
          }
        }
      }
    }
  }
  .rhch-upload-progress {
    position: absolute;
    left: 0;
    top: 180px;
    height: 4px;
    width: 100%;
    min-width: 590px;
    background: $color-upload-progress-bg;
    .rhch-upload-progress-rate {
      height: 4px;
      width: 40%;
      background: $color-text-default-button;
      // transition: width 0.5s ease-in;
    }
  }
  .rhch-file-list {
    width: 100%;
    min-width: 590px;
    .rhch-file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 2px solid $color-default;
      margin-top: 10px;
      height: 80px;
      box-sizing: border-box;
      padding: 0 16px;
      .item-left {
        display: flex;
        align-items: center;
      }
      .thumbnail-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 65px;
        text-align: center;
        position: relative;
        margin-right: 18px;
        .thumbnail-icon-box {
          display: inline-block;
          background: $color-default;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          position: relative;
        }
        &.img-box {
          border-radius: 0;
          height: 54px;
        }
        .thumbnail-img {
          width: 65px;
          height: 54px;
          pointer-events: none;
        }
        .thumbnail {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 33px;
        }
      }
      .rhcn-filename {
        font-size: 14px;
        line-height: 36px;
        font-weight: 800;
        color: $color-text-primary;
        // margin-top: -5px;
      }
      .rhcn-description {
        font-size: 12px;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 16px;
        .rhch-filesize {
          margin-right: 10px;
        }
      }
      .rhch-acctions {
        display: flex;
        align-items: center;
        color: $color-primary;
        .rhch-action {
          display: inline-block;
          width: 34px;
          height: 34px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          &:nth-child(n+2) {
            margin-left: 10px;
          }
          &:hover {
            background: $color-default;
          }
          &:active {
            background: $color-default-active;
          }
        }
        .el-icon-close {
          font-size: 25px;
          font-weight: 800;
        }
      }
    }
  }
  .rhcn-upload__tip {
    font-size: 14px;
    font-weight: normal;
    line-height: 32px;
    margin-top: 10px;
    &.error {
      color: $color-text-error;
    }
  }
  &.is-error {
    .el-upload {
      .el-upload-dragger {
        border-color: $color-text-error;
      }
    }
  }
}
</style>
